import { Component, inject } from '@angular/core';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.html',
})
export class ToastContainer {
  private readonly toastService = inject(ToastService);

  protected readonly toasts = this.toastService.toasts;

  protected readonly icons = {
    success: 'check_circle',
    error: 'warning',
    warning: 'error',
    info: 'info',
  } as const;

  // Errors and warnings must interrupt screen readers immediately; success and
  // info updates are announced politely without cutting off current speech.
  protected readonly roles = {
    success: 'status',
    error: 'alert',
    warning: 'alert',
    info: 'status',
  } as const;

  protected readonly liveness = {
    success: 'polite',
    error: 'assertive',
    warning: 'assertive',
    info: 'polite',
  } as const;

  protected dismiss(id: number): void {
    this.toastService.dismiss(id);
  }
}
